import {
  ContentWrapper,
  DeviceList,
  DeviceListBody,
  DeviceListHeader,
  DeviceListItem,
  DeviceListRow,
} from './styles'

export const ClearEnclosureFaultsUi = ({ enclosureIndex, enclosureType }) => {
  const label =
    enclosureIndex && enclosureType
      ? enclosureIndex + '::' + enclosureType
      : enclosureIndex
      ? enclosureIndex
      : enclosureType
  return (
    <ContentWrapper>
      <DeviceList>
        <DeviceListHeader>
          <DeviceListRow>
            <DeviceListItem>LOCATION</DeviceListItem>
            <DeviceListItem>STATUS</DeviceListItem>
          </DeviceListRow>
        </DeviceListHeader>
        <DeviceListBody>
          <DeviceListRow key={enclosureIndex}>
            <DeviceListItem>{label}</DeviceListItem>
            <DeviceListItem>Ready to Clear</DeviceListItem>
          </DeviceListRow>
        </DeviceListBody>
      </DeviceList>
    </ContentWrapper>
  )
}
